import React, { PropTypes } from 'react';
import { Accordion, Icon, Checkbox } from 'semantic-ui-react';

const Task = ({
  title,
  index,
  currentIndex,
  handleClick,
  taskDiagnosis,
  onToggle,
  children,
}) => {
  const active = currentIndex === index;

  const onClickToggle = evt => {
    evt.preventDefault();
    evt.stopPropagation();
    onToggle();
  };

  return (
    <div>
      <Accordion.Title
        active={active}
        index={index}
        onClick={handleClick}
        style={{ position: 'relative', color: 'black' }}
      >
        <Icon name="dropdown" />
        {title}
        <Checkbox
          toggle
          checked={taskDiagnosis.activated}
          style={{ position: 'absolute', right: '10px' }}
          onClick={onClickToggle}
        />
      </Accordion.Title>
      <Accordion.Content active={active}>{children}</Accordion.Content>
    </div>
  );
};

Task.propTypes = {
  title: PropTypes.string.isRequired,
  index: PropTypes.number.isRequired,
  currentIndex: PropTypes.number.isRequired,
  handleClick: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  taskDiagnosis: PropTypes.object.isRequired,
};

export default Task;



// WEBPACK FOOTER //
// ./src/modules/saas/pco/cases-creation/step2/components/Task.js